import { render, staticRenderFns } from "./OtrDevicesSidebar.vue?vue&type=template&id=3d8e464a&scoped=true"
import script from "./OtrDevicesSidebar.vue?vue&type=script&lang=js"
export * from "./OtrDevicesSidebar.vue?vue&type=script&lang=js"
import style0 from "./OtrDevicesSidebar.vue?vue&type=style&index=0&id=3d8e464a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8e464a",
  null
  
)

export default component.exports